import { Box } from '@change-corgi/design-system-legacy/layout';

import { DecisionMakersMainWrapper } from '../decisionMakers/DecisionMakersMainWrapper';
import { LegislativeBodiesContainer } from '../decisionMakersLegislativeBodies/LegislativeBodiesContainer';
import { ScrollTrackingWaypointContainer } from '../ScrollTrackingWaypoint';

import { useDecisionMakerSection } from './hooks/useDecisionMakerSection';

type ScrollTrackingProps = Readonly<{
	fcEnabled: boolean;
	lbsPresent: boolean;
	showLegislativeBodies: boolean;
}>;
const ScrollTracking: React.FC<ScrollTrackingProps> = ({ showLegislativeBodies }) => {
	return (
		<ScrollTrackingWaypointContainer
			name="petition_details_decision_maker_section_view"
			trackingData={{
				view_context: showLegislativeBodies ? 'legislative_bodies_version' : 'non_legislative_bodies_version',
			}}
		/>
	);
};

export const DecisionMakerSection: React.FC = () => {
	const {
		data: {
			showLegislativeBodies,
			trackingMetadata: { lbsPresent, fcEnabled, dataReadyForTracking },
		},
	} = useDecisionMakerSection();

	return (
		<>
			{dataReadyForTracking && (
				<ScrollTracking fcEnabled={fcEnabled} lbsPresent={lbsPresent} showLegislativeBodies={showLegislativeBodies} />
			)}
			{showLegislativeBodies ? (
				<Box mx={[-16, 0]}>
					<LegislativeBodiesContainer />
				</Box>
			) : (
				<DecisionMakersMainWrapper />
			)}
		</>
	);
};
